module.exports = __webpack_public_path__ + "img/mrvideo.bc501c3f.png";